import { handleActions } from 'redux-actions';
import { api } from 'js/utility/api';
import { NotificationManager } from 'react-notifications';

const LOAD_CONFIG = 'notificationConfig/LOAD_CONFIG';
const SET_CONFIG = 'notificationConfig/SET_CONFIG';
const SET_LOADING = 'notificationConfig/SET_LOADING';
const SET_ERROR = 'notificationConfig/SET_ERROR';

export const loadConfig = () => async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    try {
        const response = await api.get('/notification/config');
        dispatch({ type: SET_CONFIG, payload: response });
    } catch (error) {
        dispatch({ type: SET_ERROR, payload: error });
        console.error("Error loading notification config", error);
    } finally {
        dispatch({ type: SET_LOADING, payload: false });
    }
};

export const updateConfig = (data) => async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    try {
        const response = await api.post('/notification/update_config', data);
        dispatch({ type: SET_CONFIG, payload: response });
        NotificationManager.success('Configuración actualizada correctamente', 'Éxito');
    } catch (error) {
        dispatch({ type: SET_ERROR, payload: error });
        NotificationManager.error('Error al actualizar configuración', 'Error');
        console.error("Error updating notification config", error);
    } finally {
        dispatch({ type: SET_LOADING, payload: false });
    }
};

export const toggleNotifications = () => async (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    try {
        const response = await api.post('/notification/toggle_notifications');
        dispatch({ type: SET_CONFIG, payload: response });
        NotificationManager.success(
            `Notificaciones ${response.is_enabled ? 'Activadas' : 'Desactivadas'}`,
            'Éxito'
        );
    } catch (error) {
        dispatch({ type: SET_ERROR, payload: error });
        NotificationManager.error('Error al cambiar estado', 'Error');
    } finally {
        dispatch({ type: SET_LOADING, payload: false });
    }
};

export const testNotification = (data) => async (dispatch) => {
    try {
        await api.post('/notification/test_notification', data);
        NotificationManager.success('Notificación de prueba enviada', 'Éxito');
    } catch (error) {
        NotificationManager.error('Error al enviar prueba', 'Error');
    }
};

export const actions = {
    loadConfig,
    updateConfig,
    toggleNotifications,
    testNotification,
};

export const reducers = {
    [SET_CONFIG]: (state, { payload }) => {
        return {
            ...state,
            config: payload,
        };
    },
    [SET_LOADING]: (state, { payload }) => {
        return {
            ...state,
            loading: payload,
        };
    },
    [SET_ERROR]: (state, { payload }) => {
        return {
            ...state,
            error: payload,
        };
    },
};

export const initialState = {
    config: {
        is_enabled: false,
        firebase_credentials: {},
        server_key: ''
    },
    loading: false,
    error: null,
};

export default handleActions(reducers, initialState);
